export const keysStorage = {
  selectedClinician: 'selectedClinician',
  preferences: 'preferences',
  reservation: 'reservation',
  user: 'user',
};
